// extracted by mini-css-extract-plugin
export default {"switchCheckbox":"Switch_switchCheckbox__WWVya","switchLabel":"Switch_switchLabel__+kBDW","switchButton":"Switch_switchButton__+AE6h"};